import React from 'react';
import { getImagePath, siteConfig } from '../config/siteConfig';
import '../styles/Footer.css';

const Footer = () => {
  const { company, social } = siteConfig;

  return (
    <footer className="footer" id="contact">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <img src={getImagePath("/assets/images/logo/logo.png")} alt={company.name} className="footer-logo-img" />
            </div>
            <div className="social-links">
              {/* <a
                href={social.facebook || '#'}
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
                aria-label="Facebook"
              >
                <i className="fab fa-facebook-f"></i>
              </a> */}
              <a href={social.instagram} target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Instagram">
                <i className="fab fa-instagram"></i>
              </a>
              <a
                href={social.googleBusiness || '#'}
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
                aria-label="Google Business Profile"
              >
                <i className="fab fa-google"></i>
              </a>
            </div>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">Quick Links</h3>
            <ul className="footer-links">
              <li><a href="#home">Home</a></li>
              <li><a href="#packages">Packages</a></li>
              <li><a href="#about">About Us</a></li>
              <li><a href="#gallery">Gallery</a></li>
              <li><a href="#contact-form">Contact</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">Popular Destinations</h3>
            <ul className="footer-links">
              <li><a href="#packages">Europe Tours</a></li>
              <li><a href="#packages">Asia Adventures</a></li>
              <li><a href="#packages">Beach Holidays</a></li>
              <li><a href="#packages">Mountain Expeditions</a></li>
              <li><a href="#packages">Cultural Tours</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">Contact Info</h3>
            <div className="contact-info">
              <div className="contact-item">
                <i className="fas fa-map-marker-alt"></i>
                <div>
                  <p>{company.registeredAddress}</p>
                </div>
              </div>
              <div className="contact-item">
                <i className="fas fa-phone"></i>
                <div>
                  <p>{company.phone}</p>
                  <p>{company.alternatePhone}</p>
                </div>
              </div>
              <div className="contact-item">
                <i className="fab fa-whatsapp"></i>
                <div>
                  <p>{company.whatsapp}</p>
                </div>
              </div>
              <div className="contact-item">
                <i className="fas fa-envelope"></i>
                <div>
                  <p>{company.email}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>&copy; 2026 {company.name}. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
